import React, { useContext, useMemo } from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import config from '../config';
import { LoginContext } from '@ww/react-ui-components';

function createClient(token) {
  // Spread operation `headers` last so any explicit `authorization` from a
  // mutation's `context: { headers: ... }` overrides the LoginContext token.
  // ServerAuthHandoff relies on this to forward the Frontegg JWT.
  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...(token && { authorization: `Bearer ${token}` }),
      ...headers,
    },
  }));

  const client = new ApolloClient({
    link: authLink.concat(
      createHttpLink({
        uri: config.api.url
      })
    ),
    cache: new InMemoryCache()
  });

  return client;
}

function GqlClientProvider({ children }) {
  const {
    state: { token }
  } = useContext(LoginContext);
  const client = useMemo(() => createClient(token), [token]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}

export default GqlClientProvider;
